import React from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteNotification } from '../../api/NotificationApi';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';

const NotificationContainer = ({ notification, onDelete }) => {
    const navigate = useNavigate();

    const handleDelete = async (e) => {
        e.stopPropagation();
        try {
            await deleteNotification(notification.id);
            onDelete(notification.id);
        } catch (error) {
            console.error('알림 삭제에 실패했습니다:', error);
        }
    };

    const handleClick = () => {
        if (notification.url) {
            navigate(notification.url);
        }
    };

    return (
        <div
            className={`relative bg-white p-4 border border-gray-200 rounded-lg ${notification.url ? 'cursor-pointer active:bg-gray-50' : ''}`}
            onClick={handleClick}
        >
            <div className="flex justify-between items-start">
                <div className="flex-1">
                    <h3 className="font-semibold text-lg mb-1">{notification.title}</h3>
                    <p className="text-gray-600 mb-2">{notification.content}</p>
                    <p className="text-sm text-gray-400">
                        {format(new Date(notification.createdAt), 'M월 d일 a h:mm', { locale: ko })}
                    </p>
                </div>
                <button
                    onClick={handleDelete}
                    className="ml-2 p-2 text-gray-400 active:text-red-500 transition-colors"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default NotificationContainer;
